const LISTE_PRODUIT_RESEAU_TEMPO = {
  reseauTempo: {
    title: 'Liste des produits réseau temporaire',
    ajouter: 'Nouveau produit réseau temporaire',
  },
  reseauLc: {
    title: 'Liste des produits réseau LC',
    ajouter: 'Nouveau produit réseau LC',
  },
  reseauMairie: {
    title: 'Liste des produits réseau Mairie',
    ajouter: 'Nouveau produit réseau Mairie',
  },
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des produits réseau temporaire',
  },
  actions: {
    search: 'Rechercher',
    filtre: 'Filtre',
    exporterObjectif: 'Exporter les objectifs réseaux',
    importerObjectif: 'Importer les objectifs réseaux',
    planning: 'Editer planning réseau temporaire',
    exporterFacesReseaux: 'Exporter les faces réseaux',
  },
  popUpEditionPlanning: {
    title: 'Editer planning réseau temporaire',
    dateDebut: 'Date début',
    dateFin: 'Date fin',
    inclureCommercial: 'Afficher initiales du commercial',
  },
  popUpImportExcelTitle: 'Importer les objectifs des réseaux tempo',
  tabs: {
    reference: 'Référence',
    libelle: 'Libellé',
    ville: 'Ville',
    format: 'Format',
    type: 'Type',
    nbFacesPrevues: 'Nb faces prévues',
    nbFacesReelles: 'Nb faces réelles',
    agence: 'Agence',
    societe: 'Société',
    actif: 'Archivé',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    dateVisualisation: 'Date de visualisation',
    reference: 'Référence',
    libelle: 'Libellé',
    actif: 'Actif',
    yes: 'Oui',
    no: 'Non',
    ville: 'Ville(s)',
    departement: 'Département(s)',
    format: 'Format(s)',
    type: 'Type(s) de réseau',
    societe: 'Société',
    agence: 'Agence',
    reseauConfrere: 'Inclure réseaux confrères',
    secteurs: 'Secteurs(s)',
    hasSecteur: 'Présent dans un secteur',
    exclureVilles: 'Exclure ville(s)',
    errors: {
      dateVisualisation: 'La date de visualisation est obligatoire',
    },
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  archivage: {
    archiver: 'Etes-vous sûr de vouloir archiver ce produit ?',
    desarchiver: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    sucessArchivage: 'Produit archivé avec succès',
    successDesarchivage: 'Produit désarchivé avec succès',
  },
};

export default LISTE_PRODUIT_RESEAU_TEMPO;
